import moment from 'moment';

const GroupGrowthProductName = 'GroupGrowth';
const EnterpriseProductName = 'Thriving Teams';
const MidSizeMoversProductName = 'Mid-Sized Movers';

export const SubscriptionType = {
    StartUp: 'StartUp',
    EarlyGrower: 'EarlyGrower',
    SoloStar: 'SoloStar',
    GroupGrowth: 'GroupGrowth',
    Enterprise: 'ThrivingTeams',
    MidSizeMovers: 'MidSizeMovers'
};

export const getSubscription = () => {
    const enterpriseSub = localStorage.getItem(EnterpriseProductName);
    const groupGrowthSub = localStorage.getItem(GroupGrowthProductName);
    const midSizeMoversSub = localStorage.getItem(MidSizeMoversProductName);

    const subscription = {
        name: '',
        type: null
    };

    if (enterpriseSub && hasValidSubscription(enterpriseSub)) {
        const data = JSON.parse(enterpriseSub);
        return {
            name: 'Thriving Teams',
            type: SubscriptionType.Enterprise,
            expiry: data.expiresAt,
            isMonthly: data.intervalCount === 1
        };
    }

    if (groupGrowthSub && hasValidSubscription(groupGrowthSub)) {
        const data = JSON.parse(groupGrowthSub);
        return {
            name: 'Group Growth',
            type: SubscriptionType.GroupGrowth,
            expiry: data.expiresAt,
            isMonthly: data.intervalCount === 1
        };
    }
    if (midSizeMoversSub && hasValidSubscription(midSizeMoversSub)) {
        const data = JSON.parse(midSizeMoversSub);
        return {
            name: 'Mid-Sized Movers',
            type: SubscriptionType.MidSizeMovers,
            expiry: data.expiresAt,
            isMonthly: data.intervalCount === 1
        };
    }

    return subscription;
};

export const hasValidSubscription = (data) => {
    try {
        const subscription = JSON.parse(data);
        return moment(subscription.expiresAt).isAfter(moment());
    } catch {
        return false;
    }
};

// production priceID

export const SubscriptionList = () => {

    const data = [
        {
            id: 1,
            stripePriceId: 'price_1TZPe5EDtVnRuRIKR1xKCrNH',
            planName: 'Start Up',
            trialPeriod: 0,
            months: 1,
            originalPrice: "99",
            subscriptionType: SubscriptionType.StartUp,
            isMonthly: true,
            // color: 'linear-gradient(90deg,  #f4e2d8, #ba5370'
            color: 'linear-gradient(90deg,rgb(225, 145, 172) 0%,rgb(241, 47, 112) 100%)'
        },
        {
            id: 2,
            stripePriceId: 'price_1TZPnREDtVnRuRIKIcHkeRq3',
            planName: 'Start Up',
            trialPeriod: 0,
            months: 12,
            originalPrice: "1069",
            subscriptionType: SubscriptionType.StartUp,
            isMonthly: false,
            // color: 'linear-gradient(90deg,  #f4e2d8, #ba5370'
            color: 'linear-gradient(90deg,rgb(225, 145, 172) 0%,rgb(241, 47, 112) 100%)'
        },
        {
            id: 3,
            stripePriceId: 'price_1TZPqEEDtVnRuRIK21zt4eOB',
            planName: 'Early Grower',
            trialPeriod: 0,
            months: 12,
            originalPrice: "199",
            subscriptionType: SubscriptionType.EarlyGrower,
            isMonthly: true,
            // color: 'linear-gradient(90deg,  #f4e2d8, #ba5370'
            color: 'linear-gradient(90deg, #36b4e7 0%, #36b4e7 100%)'
        },
        {
            id: 4,
            stripePriceId: 'price_1TZPrYEDtVnRuRIKiNXjuQvb',
            planName: 'Early Grower',
            trialPeriod: 0,
            months: 12,
            originalPrice: "2149",
            subscriptionType: SubscriptionType.EarlyGrower,
            isMonthly: false,
            // color: 'linear-gradient(90deg,  #f4e2d8, #ba5370'
            color: 'linear-gradient(90deg, #36b4e7 0%, #36b4e7 100%)'
        },
        {
            id: 5,
            stripePriceId: 'price_1RV1kpEDtVnRuRIKlKByp4PZ',
            planName: 'Solo Star',
            trialPeriod: 30,
            months: 1,
            originalPrice: "499",
            subscriptionType: SubscriptionType.SoloStar,
            isMonthly: true,
            // color: 'linear-gradient(90deg,  #f4e2d8, #ba5370'
            color: 'linear-gradient(90deg,rgb(154, 239, 232) 0%,rgb(42, 236, 220) 100%)'
        },
        {
            id: 6,
            stripePriceId: 'price_1RV1lBEDtVnRuRIKr7sAWmYh',
            planName: 'Solo Star',
            trialPeriod: 30,
            months: 1,
            originalPrice: "5,389",
            subscriptionType: SubscriptionType.SoloStar,
            isMonthly: false,
            color: 'linear-gradient(90deg,rgb(158, 235, 228) 0%,rgb(32, 225, 209) 100%)'
        },
        {
            id: 7,
            stripePriceId: 'price_1RV1pwEDtVnRuRIKGwnaBhhY',
            planName: 'Group Growth',
            trialPeriod: 30,
            months: 1,
            originalPrice: "7,499",
            subscriptionType: SubscriptionType.GroupGrowth,
            isMonthly: true,
            color: 'linear-gradient(90deg, #36b4e7 0%, #36b4e7 100%)'
        },
        {
            id: 8,
            stripePriceId: 'price_1RV1qAEDtVnRuRIKgPg3qPqY',
            planName: 'Group Growth',
            trialPeriod: 30,
            months: 12,
            originalPrice: "80,989",
            subscriptionType: SubscriptionType.GroupGrowth,
            isMonthly: false,
            color: 'linear-gradient(90deg, #36b4e7 0%, #36b4e7 100%)'
        },
        {
            id: 9,
            stripePriceId: 'price_1RV1mIEDtVnRuRIKCrf0VhUG',
            planName: 'Thriving Teams',
            trialPeriod: 30,
            months: 1,
            originalPrice: "1,499",
            subscriptionType: SubscriptionType.Enterprise,
            isMonthly: true,
            color: 'linear-gradient(90deg, rgb(239, 222, 127), rgb(238, 180, 34), rgb(218, 165, 32))'
        },
        {
            id: 10,
            stripePriceId: 'price_1RV1mfEDtVnRuRIKwFqaPaNH',
            planName: 'Thriving Teams',
            trialPeriod: 30,
            months: 12,
            originalPrice: "16,189",
            subscriptionType: SubscriptionType.Enterprise,
            isMonthly: false,
            color: 'linear-gradient(90deg, rgb(239, 222, 127), rgb(238, 180, 34), rgb(218, 165, 32))'
        },
        {
            id: 11,
            stripePriceId: 'price_1RV1rXEDtVnRuRIKOU0tG73j',
            planName: 'Mid-Sized Movers',
            trialPeriod: 30,
            months: 12,
            originalPrice: "14,999",
            subscriptionType: SubscriptionType.MidSizeMovers,
            isMonthly: true,
            color: 'linear-gradient(90deg,rgb(225, 145, 172) 0%,rgb(241, 47, 112) 100%)'
        },
        {
            id: 12,
            stripePriceId: 'price_1RV1rmEDtVnRuRIKdtLyg3Hz',
            planName: 'Mid-Sized Movers',
            trialPeriod: 30,
            months: 12,
            originalPrice: "161,989",
            subscriptionType: SubscriptionType.MidSizeMovers,
            isMonthly: false,
            color: 'linear-gradient(90deg, #e14377 0%, #e14377 100%)'
        }
    ];

    return data.map(plan => ({
        ...plan,
        price: plan.originalPrice,
        period: plan.isMonthly ? 'Monthly' : 'Annually'
    }));
};

// Test priceId

// export const SubscriptionList = () => {

//     const data = [
//         {
//             id: 1,
//             stripePriceId: 'price_1TZPzZEDtVnRuRIKAGm6E1Nb',
//             planName: 'Start Up',
//             trialPeriod: 0,
//             months: 1,
//             originalPrice: "99",
//             subscriptionType: SubscriptionType.StartUp,
//             isMonthly: true,
//             // color: 'linear-gradient(90deg,  #f4e2d8, #ba5370'
//             color: 'linear-gradient(90deg,rgb(225, 145, 172) 0%,rgb(241, 47, 112) 100%)'
//         },
//         {
//             id: 2,
//             stripePriceId: 'price_1TZQ0EEDtVnRuRIKTw7kLOfM',
//             planName: 'Start Up',
//             trialPeriod: 30,
//             months: 12,
//             originalPrice: "1069",
//             subscriptionType: SubscriptionType.StartUp,
//             isMonthly: false,
//             // color: 'linear-gradient(90deg,  #f4e2d8, #ba5370'
//             color: 'linear-gradient(90deg,rgb(225, 145, 172) 0%,rgb(241, 47, 112) 100%)'
//         },
//         {
//             id: 3,
//             stripePriceId: 'price_1TZQ0eEDtVnRuRIKcEpFbCE8',
//             planName: 'Early Grower',
//             trialPeriod: 0,
//             months: 12,
//             originalPrice: "199",
//             subscriptionType: SubscriptionType.EarlyGrower,
//             isMonthly: true,
//             // color: 'linear-gradient(90deg,  #f4e2d8, #ba5370'
//             color: 'linear-gradient(90deg, #36b4e7 0%, #36b4e7 100%)'
//         },
//         {
//             id: 4,
//             stripePriceId: 'price_1TZQ0zEDtVnRuRIKCJFMHAEO',
//             planName: 'Early Grower',
//             trialPeriod: 30,
//             months: 12,
//             originalPrice: "2149",
//             subscriptionType: SubscriptionType.EarlyGrower,
//             isMonthly: false,
//             // color: 'linear-gradient(90deg,  #f4e2d8, #ba5370'
//             color: 'linear-gradient(90deg, #36b4e7 0%, #36b4e7 100%)'
//         },
//         {
//             id: 5,
//             stripePriceId: 'price_1RV1NVEDtVnRuRIKUfCAmKUn',
//             planName: 'Solo Star',
//             trialPeriod: 30,
//             months: 1,
//             originalPrice: "499",
//             subscriptionType: SubscriptionType.SoloStar,
//             isMonthly: true,
//             // color: 'linear-gradient(90deg,  #f4e2d8, #ba5370'
//             color: 'linear-gradient(90deg,rgb(154, 239, 232) 0%,rgb(42, 236, 220) 100%)'
//         },
//         {
//             id: 5,
//             stripePriceId: 'price_1RV1OAEDtVnRuRIKGEiQWADo',
//             planName: 'Solo Star',
//             trialPeriod: 30,
//             months: 1,
//             originalPrice: "5,389",
//             subscriptionType: SubscriptionType.SoloStar,
//             isMonthly: false,
//             color: 'linear-gradient(90deg,rgb(158, 235, 228) 0%,rgb(32, 225, 209) 100%)'
//         },
//         {
//             id: 7,
//             stripePriceId: 'price_1RV1XgEDtVnRuRIK1Omjzgx1',
//             planName: 'Group Growth',
//             trialPeriod: 30,
//             months: 1,
//             originalPrice: "7,499",
//             subscriptionType: SubscriptionType.GroupGrowth,
//             isMonthly: true,
//             color: 'linear-gradient(90deg, #36b4e7 0%, #36b4e7 100%)'
//         },
//         {
//             id: 8,
//             stripePriceId: 'price_1RV1Y6EDtVnRuRIKtJnT5LcG',
//             planName: 'Group Growth',
//             trialPeriod: 30,
//             months: 12,
//             originalPrice: "80,989",
//             subscriptionType: SubscriptionType.GroupGrowth,
//             isMonthly: false,
//             color: 'linear-gradient(90deg, #36b4e7 0%, #36b4e7 100%)'
//         },
//         {
//             id: 9,
//             stripePriceId: 'price_1RV1UREDtVnRuRIK5MDsRGBN',
//             planName: 'Thriving Teams',
//             trialPeriod: 30,
//             months: 1,
//             originalPrice: "1,499",
//             subscriptionType: SubscriptionType.Enterprise,
//             isMonthly: true,
//             color: 'linear-gradient(90deg, rgb(239, 222, 127), rgb(238, 180, 34), rgb(218, 165, 32))'
//         },
//         {
//             id: 10,
//             stripePriceId: 'price_1RV1VEEDtVnRuRIKMDz5GIGj',
//             planName: 'Thriving Teams',
//             trialPeriod: 30,
//             months: 12,
//             originalPrice: "16,189",
//             subscriptionType: SubscriptionType.Enterprise,
//             isMonthly: false,
//             color: 'linear-gradient(90deg, rgb(239, 222, 127), rgb(238, 180, 34), rgb(218, 165, 32))'
//         },
//         {
//             id: 11,
//             stripePriceId: 'price_1RV1e6EDtVnRuRIKV0jSfUpk',
//             planName: 'Mid-Sized Movers',
//             trialPeriod: 30,
//             months: 12,
//             originalPrice: "14,999",
//             subscriptionType: SubscriptionType.MidSizeMovers,
//             isMonthly: true,
//             color: 'linear-gradient(90deg,rgb(225, 145, 172) 0%,rgb(241, 47, 112) 100%)'
//         },
//         {
//             id: 12,
//             stripePriceId: 'price_1RV1eaEDtVnRuRIK50O2V21L',
//             planName: 'Mid-Sized Movers',
//             trialPeriod: 30,
//             months: 12,
//             originalPrice: "161,989",
//             subscriptionType: SubscriptionType.MidSizeMovers,
//             isMonthly: false,
//             color: 'linear-gradient(90deg,rgb(225, 145, 172) 0%,rgb(241, 47, 112) 100%)'
//         }
//     ];

//     return data.map(plan => ({
//         ...plan,
//         price: plan.originalPrice,
//         period: plan.isMonthly ? 'Monthly' : 'Annually'
//     }));
// };


// Updated New Pricing (Live Mode):

// Calcium – Solo Stars:
// Monthly: price_1RV1kpEDtVnRuRIKlKByp4PZ = $499
// Yearly:  price_1RV1lBEDtVnRuRIKr7sAWmYh = $5,389
// Free Trial Period: 30 Days


// Calcium – Thriving Teams:
// Monthly: price_1RV1mIEDtVnRuRIKCrf0VhUG = $1,499
// Yearly:  price_1RV1mfEDtVnRuRIKwFqaPaNH = $16,189
// Free Trial Period: 30 Days


// Calcium – Growing Groups:
// Monthly: price_1RV1pwEDtVnRuRIKGwnaBhhY = $7,499
// Yearly:  price_1RV1qAEDtVnRuRIKgPg3qPqY = $80,989
// Free Trial Period: 30 Days


// Calcium – Mid-Size Movers:
// Monthly: price_1RV1rXEDtVnRuRIKOU0tG73j = $14,999
// Yearly:  price_1RV1rmEDtVnRuRIKdtLyg3Hz = $161,989
// Free Trial Period: 30 Days


// Calcium – Powerhouse Practices:
// Monthly: price_1RV1svEDtVnRuRIKC54e8O5v	 = $29,999
// Yearly:  price_1RV1tCEDtVnRuRIKeplSoclQ = $323,989
// Free Trial Period: 30 Days

// Calcium – Enterprise:
// Button - Call or Contact Us

// Updated New Pricing (Test Mode):

// Calcium – Solo Stars:
// Monthly: price_1RV1NVEDtVnRuRIKUfCAmKUn = $499
// Yearly:  price_1RV1OAEDtVnRuRIKGEiQWADo = $5,389
// Free Trial Period: 30 Days


// Calcium – Thriving Teams:
// Monthly: price_1RV1UREDtVnRuRIK5MDsRGBN = $1,499
// Yearly:  price_1RV1VEEDtVnRuRIKMDz5GIGj = $16,189
// Free Trial Period: 30 Days


// Calcium – Growing Groups:
// Monthly: price_1RV1XgEDtVnRuRIK1Omjzgx1 = $7,499
// Yearly:  price_1RV1Y6EDtVnRuRIKtJnT5LcG = $80,989
// Free Trial Period: 30 Days


// Calcium – Mid-Size Movers:
// Monthly: price_1RV1e6EDtVnRuRIKV0jSfUpk = $14,999
// Yearly:  price_1RV1eaEDtVnRuRIK50O2V21L = $161,989
// Free Trial Period: 30 Days


// Calcium – Powerhouse Practices:
// Monthly: price_1RV1gmEDtVnRuRIKwZQW8mdy	 = $29,999
// Yearly:  price_1RV1hKEDtVnRuRIKLbanR2fy = $323,989
// Free Trial Period: 30 Days


// Calcium – Enterprise:
// Button - Call or Contact Us
